import * as orgActions from './organization.actions';
import { initialState } from './organization.state';
import { createReducer, on } from '@ngrx/store';

/**
 * Reducer function for handling settings organization-related actions.
 * 
 * This reducer updates the state based on various organization actions such as updating the organization,
 * uploading a logo, and deleting a logo. It handles the status updates for these actions, including loading,
 * success, and error states.
 * 
 * Actions handled:
 * - `orgActions.updateOrganization`: Sets `updateStatus` to 1 (Loading) and clears `errorActions`.
 * - `orgActions.uploadLogo`: Sets `uploadStatus` to 1 (Loading) and clears `errorActions`.
 * - `orgActions.deleteLogo`: Sets `deleteStatus` to 1 (Loading) and clears `errorActions`.
 * - `orgActions.updateOrganizationSuccess`: Sets `updateStatus` to 2 (Done), updates the `organization` state, and clears `errorActions`.
 * - `orgActions.uploadLogoSuccess`: Sets `uploadStatus` to 2 (Done), updates the `logoResponse` state, and clears `errorActions`.
 * - `orgActions.deleteLogoSuccess`: Sets `deleteStatus` to 2 (Done), updates the `logoResponse` state, and clears `errorActions`.
 * - `orgActions.updateOrganizationError`: Sets `updateStatus` to 3 (Error) and updates `errorActions`.
 * - `orgActions.uploadLogoError`: Sets `uploadStatus` to 3 (Error) and updates `errorActions`.
 * - `orgActions.deleteLogoError`: Sets `deleteStatus` to 3 (Error) and updates `errorActions`.
 * - `orgActions.ClearLogoFailures`: Clears `errorActions` and resets it to the initial state.
 * 
 * @param state - The current state of the organization.
 * @param action - The action dispatched.
 * @returns The updated state based on the action type.
 */
export const organizationReducer = createReducer(
    initialState,
    // Update status for initial actions
    on(orgActions.updateOrganization, (state) => ({...state, errorActions: null, actionsStatus: {...state.actionsStatus, updateStatus: 1} })), // 1: Loading
    on(orgActions.uploadLogo, (state) => ({...state, errorActions: null, actionsStatus: {...state.actionsStatus, uploadStatus: 1} })),           // 1: Loading
    on(orgActions.deleteLogo, (state) => ({...state, errorActions: null, actionsStatus: {...state.actionsStatus, deleteStatus: 1}})),           // 1: Loading
    // Update status for success actions
    on(orgActions.updateOrganizationSuccess, (state, { organization }) => ({...state, organization: organization, errorActions: null, actionsStatus: {...state.actionsStatus, updateStatus: 2} })), // 2: Done
    on(orgActions.uploadLogoSuccess, (state, { response }) => ({...state, logoResponse: response, errorActions: null, actionsStatus: {...state.actionsStatus, uploadStatus: 2} })),     // 2: Done
    on(orgActions.deleteLogoSuccess, (state, { response }) => ({...state, logoResponse: response, errorActions: null, actionsStatus: {...state.actionsStatus, deleteStatus: 2} })),     // 2: Done
    // Update status for error actions
    on(orgActions.updateOrganizationError, (state, { error }) => ({...state, errorActions: error,actionsStatus: {...state.actionsStatus, updateStatus: 3} })), // 3: Error
    on(orgActions.uploadLogoError, (state, { error }) => ({...state, errorActions: error, actionsStatus: {...state.actionsStatus, uploadStatus: 3} })),           // 3: Error
    on(orgActions.deleteLogoError, (state, { error }) => ({...state, errorActions: error, actionsStatus: {...state.actionsStatus, deleteStatus: 3} })),            // 3: Error
    on(orgActions.clearLogoFailures, state => ({
            ...state,
            errorActions: initialState.errorActions ,
            actionsStatus: initialState.actionsStatus

        })),
);